import React, { useState, useEffect } from 'react';
import CONSTANTS, { computeBasedness } from '../constants';

function GameReplay({ gamePlayUUID }) {
    const [gameData, setGameData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        let url = CONSTANTS.BACKEND_URL;
        const params = new URLSearchParams();
        params.append('gamePlayUUID', gamePlayUUID);
    
        if (params.toString()) {
            url += '?' + params.toString();
        }

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch game data');
                }
                return response.json();
            })
            .then(data => {
                console.log(data);
                setGameData(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setLoading(false);
            });
    }, [gamePlayUUID]);

    if (loading) {
        return <div>Loading game data...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const boardStateChanges = gameData && gameData[0] && gameData[0].gameStats.M.boardStateChanges.L;
    let flattenedChanges = [];

    if (boardStateChanges) {
        boardStateChanges.forEach(change => {
            const time = change.M && change.M.t && change.M.t.N;  // Assumes 't' is a string. Adjust if different type.
            const changes = change.M && change.M.changes && change.M.changes.L;

            if (changes) {
                changes.forEach(ch => {
                    flattenedChanges.push([time, ch.M[0].N, ch.M[1].N, ch.M[2].N]);
                });
            }
        });
    }

    return (
        <div>
            <p>Got data for gameplay : {gamePlayUUID}</p>
            <table>
                <thead>
                    <tr>
                        <th>State Change</th>
                    </tr>
                </thead>
                <tbody>
                    {flattenedChanges && flattenedChanges.map((change, index) => {
                        console.log(change);
                        return (
                        
                        <tr key={index}>
                            <td>time since start in ms: {change[0]}</td>
                            <td>( {change[1]} , {change[2]}, ) = {change[3]}</td>

                        </tr>
                    );})}
                </tbody>
            </table>
        </div>
    );
}

export default GameReplay;
